<div class="wrapper">
  <!-- topbar -->
  <app-topbar></app-topbar>

  <div class="content-page">
    <div class="content" [class.no-scroll]="loading.routerLoading | async">
      <div class="container-fluid">

        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="loading" *ngIf="loading.routerLoading | async">
      <app-ui-preloader [display]="true"></app-ui-preloader>
      <div class="loading-text">Loading ...</div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
